import { Data } from '@angular/router';

export interface IModalSetting {
    actions?: Data;
}
